import styled from 'styled-components'
import { UnorderedList } from 'components/list'
import Paragraph from 'components/typography/paragraph'

export const Popover = styled.div`
    grid-template-rows: auto minmax(0, 1fr) auto;
    row-gap: 8px;

    border: 1px solid var(--huma-color-border-default);
    border-radius: var(--border-radius);
    min-height: 162px;
    padding: 8px;
    background-color: var(--huma-color-surface-elevated);
    box-shadow:
        0 12px 24px 0 rgb(from var(--huma-palette-neutral-10) r g b / .2),
        0 0 32px 0 rgb(from var(--huma-palette-neutral-10) r g b / .1);

    transform: inherit; /* Copy the transform from the main command bar */

    @supports (width: anchor-size(width)) {
        position-anchor: --command-bar;

        inset: unset;
        inset-block-end: calc(anchor(bottom) + 51px);
        inset-inline-end: calc(anchor(right) + 9px);

        width: calc(anchor-size(inline) / 2);
        max-height: calc(anchor-size(height) - 80px);
    }

    @supports not (width: anchor-size(width)) {
        position: absolute;

        inset-block-end: 50px;
        inset-inline-end: 8px;

        width: 50%;
        height: fit-content;
        max-height: calc(100% - 80px);

        &.hidden {
            display: none;
        }
    }

    &:is(:popover-open, .visible) {
        display: grid;
    }
`

export const Actions = styled(UnorderedList)`
    overflow-y: auto;

    margin-inline: -8px;
    padding-inline: 8px;
`

export const EmptyText = styled(Paragraph).attrs({ className: 'caption center' })`
    margin-block-end: 16px;
`